import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const maxLength = 10;

const index = ({
  project,
  index,
  handleEditClick,
  handleEditableChange,
  handleUpdateClick,
  handleCancelClick,
}) => {
  const firstUnderscoreIndex = project.projectName.indexOf("_");
  const serialNumber = project.projectName.substring(0, firstUnderscoreIndex);
  const editableText = project.projectName.substring(firstUnderscoreIndex + 1);
  const inputRef = useRef();
  useEffect(() => {
    inputRef.current && inputRef.current.focus();
  }, [project]);

  if (project.isEditing) {
    return (
      <div className="flex  w-max justify-between  p-2 items-center ">
        <p>{serialNumber}_</p>
        <input
          ref={inputRef}
          type="text"
          value={project.editableProjectName}
          onChange={(e) => handleEditableChange(e, index)}
          className="  px-1  w-20 text-[12px] outline-slate-500 "
        />
        <CorrectIcon onclickFunction={() => handleUpdateClick(index)} />
        <CrossIcon onclickFunction={() => handleCancelClick(index)} />
      </div>
    );
  }
  return (
    <div className="flex justify-between  w-60 px-10 py-2 items-center ">
      <Link
        style={{ fontSize: "12px", fontWeight: 700 }}
        className=" text-primaryColor  "
        to={`/quote-versions/${project.RefId}`}
      >
        <span>{serialNumber}_</span>
        <span>
          {editableText.length > maxLength
            ? editableText.slice(0,maxLength) + "..."
            : editableText}
        </span>
      </Link>
      <svg
        onClick={() => handleEditClick(index)}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide lucide-pen h-4 "
      >
        <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" />
      </svg>
    </div>
  );
};

export default index;

export const CorrectIcon = ({ onclickFunction }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-check h-4 text-green-500 mx-2"
      onClick={onclickFunction}
    >
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
};

export const CrossIcon = ({ onclickFunction, additionalClasses }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class={`lucide lucide-plus h-4   rotate-45 text-red-500 ${additionalClasses}`}
      onClick={onclickFunction}
    >
      <path d="M5 12h14" />
      <path d="M12 5v14" />
    </svg>
  );
};
